/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createConj } from '../../factoriesAny.js';
export var conjDependencies = {
  typedDependencies: typedDependencies,
  createConj: createConj
};